/**
 * H5b — FAIR Services section cards
 * Figma RedisignHomePage `15:9694` desktop · `15:9605` compact
 * Order L→R: Style Space → Size charts → Taste
 */

import sizeChartsPosterUrl from '@/assets/home-v2/services/size-charts-poster.webp'
import sizeChartsVideoUrl from '@/assets/home-v2/services/size-charts.mp4'
import styleSpacePosterUrl from '@/assets/home-v2/services/style-space-poster.webp'
import styleSpaceVideoUrl from '@/assets/home-v2/services/style-space.mp4'
import tasteFeedPosterUrl from '@/assets/home-v2/services/taste-feed-poster.webp'
import tasteFeedVideoUrl from '@/assets/home-v2/services/taste-feed.mp4'
import {
  PROFILE_MY_PARAMETERS_ROUTE,
  STYLE_SPACE_ROUTE,
} from '@/router/routes'

export type FairHomeV2ServiceId = 'style-space' | 'size-charts' | 'taste-feed'

export type FairHomeV2ServiceAction =
  | { type: 'route'; to: string }
  | { type: 'taste-modal' }

/**
 * Hover video (`vids/fair services/scene N.mp4` → 960² h264, no audio).
 * Every scene is a loop: frame 0 ≡ last frame, so the poster is frame 0 and
 * the still ↔ video hand-off is invisible in both directions.
 */
export interface FairHomeV2ServiceCard {
  id: FairHomeV2ServiceId
  /** Poster — exact frame 0 of `videoUrl`. */
  imageUrl: string
  videoUrl: string
  imageAltKey: string
  titleKey: string
  descriptionKey: string
  ctaKey: string
  action: FairHomeV2ServiceAction
}

export const FAIR_HOME_V2_SERVICES: FairHomeV2ServiceCard[] = [
  {
    id: 'style-space',
    imageUrl: styleSpacePosterUrl,
    videoUrl: styleSpaceVideoUrl,
    imageAltKey: 'fair_home_v2.services.style_space.image_alt',
    titleKey: 'fair_home_v2.services.style_space.title',
    descriptionKey: 'fair_home_v2.services.style_space.description',
    ctaKey: 'fair_home_v2.services.style_space.cta',
    action: { type: 'route', to: STYLE_SPACE_ROUTE },
  },
  {
    id: 'size-charts',
    imageUrl: sizeChartsPosterUrl,
    videoUrl: sizeChartsVideoUrl,
    imageAltKey: 'fair_home_v2.services.size_charts.image_alt',
    titleKey: 'fair_home_v2.services.size_charts.title',
    descriptionKey: 'fair_home_v2.services.size_charts.description',
    ctaKey: 'fair_home_v2.services.size_charts.cta',
    action: { type: 'route', to: PROFILE_MY_PARAMETERS_ROUTE },
  },
  {
    id: 'taste-feed',
    imageUrl: tasteFeedPosterUrl,
    videoUrl: tasteFeedVideoUrl,
    imageAltKey: 'fair_home_v2.services.taste_feed.image_alt',
    titleKey: 'fair_home_v2.services.taste_feed.title',
    descriptionKey: 'fair_home_v2.services.taste_feed.description',
    ctaKey: 'fair_home_v2.services.taste_feed.cta',
    action: { type: 'taste-modal' },
  },
]
